import { render, staticRenderFns } from "./ValidasiIKPDetail.vue?vue&type=template&id=756b4982&scoped=true&lang=html&"
import script from "./ValidasiIKPDetail.vue?vue&type=script&lang=js&"
export * from "./ValidasiIKPDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b4982",
  null
  
)

export default component.exports